import { Container } from 'react-bootstrap'

import NavbarPages from '../NavbarPages'
import HeaderPages from '../HeaderPages'
import KiveUso from '../../../Resourses/products/rami-uso-solo.svg'

const imgHeader = "./images/productos/header-productos-rami-cintas-seguridad.jpg";
const imgThumbIzq = "./images/productos/productos_thumbs--cinta--seguridad--rami.jpg";
const altText = "CINTA DE EMPAQUE";

const tipoColor = 'productos__detail--tipoSeguridadRami'

const detailLine1 = "CINTAS";
// const detailLine2 = "ADHESIVA";
const detailLine3 = "DE SEGURIDAD";

const imgTable ="./images/productos/rami/cuadro-rami-cinta-seguridad.jpg";


const textoDetail1 = 'Cintas de polipropileno impresa FAJA DE SEGURIDAD, ideal para los envios E-Commerce con el fin de darle mejor protección y garantía a los productos despachados.'
const textoDetail2 = 'Las cintas de PELIGRO y PRECAUCION son de uso indicativo, NO adhesivas.'
const textoDetail3 = 'Cintas de polipropileno adhesivas, con impreso FAJA DE SEGURIDAD y FRÁGIL, ideales para los envios E-Commerce con el fin de darle mejor protección y garantía a los productos despachados.'
const textoDetail4 = 'Las cintas de PELIGRO y PRECAUCION son de uso indicativo, NO adhesivas.'

const imgThumb1 = './images/productos/rami/rami-cinta-de-seguridad-1.jpg';
const imgThumb1Alt = 'Cintas de seguridad.';

const imgThumb2 = './images/productos/rami/rami-cinta-de-seguridad-2.jpg';
const imgThumb2Alt = 'intas de seguridad.';

const imgThumb3 = './images/productos/rami/rami-cinta-de-seguridad-3.jpg';
const imgThumb3Alt = 'intas de seguridad.';

const imgThumb4 = './images/productos/rami/rami-cinta-de-seguridad-4.jpg';
const imgThumb4Alt = 'Cintas de seguridad blanca.';

const imgThumb5 = './images/productos/rami/rami-cinta-de-seguridad-5.jpg';
const imgThumb5Alt = 'Cintas de seguridad amarilla.';

const imgThumb6 = './images/productos/rami/rami-cinta-de-seguridad-6.jpg';
const imgThumb6Alt = 'Cintas de seguridad amarilla.';

const CintaSeguridadRami = () => {
  return (
    <Container className='mb-0'>
        <NavbarPages className="p-0" />
        <div className='row'>
          <div className='col-12 mb-4'>
            <HeaderPages img={imgHeader} alt={"Productos Kive Cintas"} />
          </div>
          <div className='col-12 col-sm-6 col-md-5 productos__imgContainer'>
            <img 
              src={imgThumbIzq} 
              alt={altText} 
              className='d-block w-100 productos__imgContainer--img' 
              loading='lazy'/>
          </div>
          <div className='col-12 col-sm-12 col-md-7 productos__vert--int mb-4 mt-1'>
            <div className='row productos__detail'>
              <div className='col-12'>
                <p className={`productos__detail--tipo ${tipoColor}`}>{detailLine1}
                 {/* <span className={`productos__detail--caracteristica ${tipoColor}`}> {detailLine2}</span> */}
                </p>
                <p className={`productos__detail--caracteristica ${tipoColor}`}>{detailLine3}</p>
                <img src={KiveUso} className='d-block productos__detail--svg' alt='' loading="lazy" />
              </div>
              <div className='col-12 productos__detail'>
                <img  src={imgTable} 
                      className='d-block w-100' 
                      alt={altText}
                      loading="lazy" />
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-12 productos__vert mb-4 mt-1'>
            <p className='site_text productos__text--int mb-0'> 
              {textoDetail3}<br /><br />
              {textoDetail4}
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb1} className='d-block w-100 p-0 m-0 ' alt={ imgThumb1Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb2} className='d-block w-100 p-0 m-0 ' alt={ imgThumb2Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb3} className='d-block w-100 p-0 m-0 ' alt={ imgThumb3Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb4} className='d-block w-100 p-0 m-0 ' alt={ imgThumb4Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb5} className='d-block w-100 p-0 m-0 ' alt={ imgThumb5Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb6} className='d-block w-100 p-0 m-0 ' alt={ imgThumb6Alt} loading="lazy" />
            </div>
        </div>       
      </Container>
    
  )
}

export default CintaSeguridadRami